import { FlexDiv } from 'components/generic/HomePageComponents'

const ProfileCardsContainer = (props) => (
  <FlexDiv
    display='flex'
    justifyContent={['center', 'space-between']}
    flexDirection={['column', 'column', 'column', 'row']}
    {...props}
  />
)

export default ProfileCardsContainer
